import classNames from "classnames";

import Link from "next/link";

import GlobeIcon from "assets/careers/globe.svg";

import SectionHeader from "./SectionHeader";

import styles from "./OpenPositions.module.css";

import type { Job } from "lib/localContent";

type PropTypes = {
  jobs: Job[];
};

const OpenPositions = ({ jobs }: PropTypes) => (
  <div className={styles.openPositions}>
    <SectionHeader title="Open positions" anchor="open-positions">
      Work from home, or from wherever makes you happy.
      <span className={styles.tag}>
        <span className={styles.tagInner}>
          <GlobeIcon className={classNames("icon", styles.tagIcon)} />
          <span className={styles.tagText}>All positions are fully remote in UTC ± 3 hours timezone</span>
        </span>
      </span>
    </SectionHeader>

    <div className={styles.jobsWrapper}>
      {jobs.map((job) => (
        <Link href={`/jobs/${job.slug}`} key={job.slug}>
          <a className={styles.jobLink}>
            <strong className={styles.jobTitle}>{job.title}</strong>
            <p className={styles.jobDescription}>{job.desc}</p>
            <span className={styles.salaryWord}>Salary</span>
            {job.salary_from !== undefined || job.salary_to !== undefined ? (
              <span className={styles.salary}>
                {[job.salary_from, job.salary_to]
                  .filter((salary) => salary !== undefined)
                  .map((salary) => `$${salary?.toLocaleString()}`)
                  .join(" - ")}
              </span>
            ) : null}
          </a>
        </Link>
      ))}
    </div>

    <div className={styles.referralWrapper}>
      <div className={styles.announcementOuter}>
        <div className={styles.announcement}>
          <div>
            <h3>Know a great Developer Advocate?</h3>
            <p>
              Refer and get a <strong>$15k bonus</strong> for a successful candidate.
            </p>
          </div>
          <a className={styles.readMore} href="mailto:referral@raycast.com">
            <span>Send email</span>
            <i>→</i>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default OpenPositions;
